import React from 'react';

export const themes = {
   light: {
     name: 'light',
     body: '#f3f3f3',
     text: '#262626',
     cardPrimary: '#fbfbfb',
     cardSecondary: '#ededed',
     subtle: 'rgba(0, 0, 0, 0.3)',
     white: '#f3f3f3',
     black: '#262626',
     primary: 'purple',
     warning: 'yellow',
     danger: 'red'
   },
   dark: {
      name: 'dark',
      body: '#262626',
      text: '#f3f3f3',
      cardPrimary: '#2d2d2d',
      cardSecondary: '#242424',
      subtle: 'rgba(256, 256, 256, 0.3)',
      white: '#f3f3f3',
      black: '#262626',
      primary: 'purple',
      warning: 'yellow',
      danger: 'red'
   },
 };

export const ThemeContext = React.createContext({
  theme: themes.light,
  toggleTheme: undefined
});